import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(db: AngularFirestore) {
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// C:/Users/beast/repos/athlos-admin/src/app/app.component.ts